<div id="floating-button-order-result" fxLayout="column" fxLayoutAlign="start center">
    <dx-load-panel
        shadingColor="rgba(0,0,0,0.4)"
        [(visible)]="IsLoading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw !important;">
        <dx-toolbar id="navigation-header"
                    style="padding-right: 16px!important; width: 100%"
                    [ngStyle.lt-md]="{height: '46px'}" (onContentReady)="onToolbarReady($event)">
            <dxi-item location="before">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxShow fxHide.xs>
                    <h3 class="padding-block" style="padding-left: 24px !important;">
                        Order {{order?.codeValue}} Results
                    </h3>
                    <span [innerHTML]="Status"></span>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between center" fxShow fxHide.gt-xs
                     style="width: 130px; margin-top: 5px">
                    <h5 class="padding-block" style="margin-top: 0; margin-bottom: 0">
                        Order {{order?.codeValue}} Results
                    </h5>
                    <span [innerHTML]="Status"></span>
                </div>
            </dxi-item>

            <dxi-item fxShow fxHide.lt-md location="after">
                <dx-button [text]="'Cumulative Results'" (click)="openCumulativeResults()"></dx-button>
            </dxi-item>
            <dxi-item fxShow fxHide.lt-md location="after">
                <dx-button [text]="'Email Results'" [disabled]="orderId === undefined || orderId === null"
                           (onClick)="openEmailFax('email')"></dx-button>
            </dxi-item>
            <dxi-item fxShow fxHide.lt-md location="after">
                <dx-button [text]="'Fax Results'" [disabled]="orderId === undefined || orderId === null"
                           (onClick)="openEmailFax('fax')"></dx-button>
            </dxi-item>
            <dxi-item fxShow fxHide.lt-md location="after">
                <dx-button [text]="'Print Results'" (onClick)="printResults()"></dx-button>
            </dxi-item>
          <dxi-item fxShow fxHide.lt-md location="after">
            <dx-button #unsignBtn [visible]="order.hasSignature"
                       *ngIf='orderId !== -1'
                       [text]="'Unsign'"
                       [disabled]="Status === 'FINAL'|| Status === 'CANCELED'"
                       (click)="openUnsignDialog()"
            ></dx-button>
          </dxi-item>
          <dxi-item fxShow fxHide.lt-md location="after">
            <dx-button #signBtn [text]="'Sign'" [visible]="!order.hasSignature"
                       *ngIf='orderId !== -1'
                       [disabled]="Status === 'FINAL' || Status === 'CANCELED'"
                       (click)="openSignDialog()">
            </dx-button>
          </dxi-item>
        </dx-toolbar>
        <app-order-header fxShow fxHide.lt-md [patient]="OrderPatient" [physician]="OrderPhysician" [order]="order"
                          [client]="order.patientClient"></app-order-header>
    </div>

    <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw !important;">
        <div fxShow fxHide.lt-md fxLayout="row" fxLayoutAlign="space-between">
            <div class="ocl-container-with-padding" style="width: 100%">
                <div>
                    <h4>Order Comments</h4>
                    <div fxLayout="row" fxLayoutAlign="space-between">
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" style="height: 200px">
                    <dx-html-editor #editor [width]="'100%'" valueType="html" [value]="order ? order?.reportComment : ''" [readOnly]="true">
                    </dx-html-editor>
                </div>
            </div>
            <div class="ocl-container-with-padding" style="width: 100%">
                <div>
                    <h4>Cancellation Reasons</h4>
                    <div fxLayout="row" fxLayoutAlign="space-between">
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" style="height: 200px">
                    <dx-html-editor #editor [width]="'100%'" valueType="html" [value]="CancellationReasons" [readOnly]="true">
                    </dx-html-editor>
                </div>
            </div>
            <div class="ocl-container-with-padding" style="width: 100%;">
                <div>
                    <div fxLayout="row" fxLayoutAlign="space-between end">
                        <h4>Order Documents</h4>

                        <input type="file" (change)="onFileChanged($event)" style="display: none" #fileInput/>
                        <dx-button [disabled]="isUploading" icon="fa fa-upload" text="Upload"
                                   (click)="fileInput.click()" style="max-height: 26px; margin-bottom: 4px"></dx-button>

                    </div>
                </div>
                <div class="dx-card" fxLayout="row" fxLayoutAlign="space-between" style="height: 200px;">
                    <dx-list [items]="docs" height="100%">
                        <div *dxTemplate="let document of 'item'">
                          <div fxLayout="row" fxLayoutAlign="space-between">
                            <div style='display: inline-flex; width: 100%'>
                              {{document.name}}
                              <span style='flex: 1'></span>
                              <div>
                                <dx-button icon='fas fa-eye' hint='View' (onClick)='documentClick(document.name)'></dx-button>
                                <dx-button icon='fas fa-trash' hint='Remove' (onClick)='documentRemove(document.id)' style='margin-left: 4px'></dx-button>
                              </div>
                            </div>
                          </div>
                        </div>
                    </dx-list>
                </div>
            </div>
        </div>
        <div fxShow fxHide.gt-sm fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px">
            <dx-accordion [collapsible]="false" [multiple]="false" [animationDuration]="300" width="100%"
                          height="fit-content" [selectedIndex]="0">
                <dxi-item title="Patient Information" class="item-accordion">
                    <address class="details">
                        <span class="strong">Patient ID:</span> {{ PatientCode }}<br/>
                        <span class="strong">Patient:</span> {{ PatientFullName }} {{ DOB }} {{ Gender }}<br/>
                        <span class="strong">Primary Physician:</span> {{ PatientPrimaryPhysician }}<br/>
                        <span class="strong">Room:</span> {{ Room }} <span class="strong">Unit:</span> {{ Unit }}<br/>
                        <span class="strong">Address:</span> {{ PatientAddress }}<br/>
                        <span class="strong">Phone:</span> {{ Patient.phone }}<br/>
                    </address>
                </dxi-item>
                <dxi-item title="Order Information" class="item-accordion">
                    <address class="details">
                        <span
                            class="strong">Collected:</span> {{ CollectionDate }}
                        <br/>
                        <span
                            class="strong"> Received:</span> {{ ReceivedDate }}
                        <br/>
                        <span
                            class="strong">Reported:</span> {{ ReportedDate }}
                        <br/>
                        <span class="strong">Collection Site:</span> {{CollectionSites}} <br/>
                        <span class="strong">Ordering Physician:</span> {{Physician}}
                    </address>
                </dxi-item>
                <dxi-item title="Client Information" class="item-accordion">
                    <address class="details">
                        <span class="strong">Name:</span> {{ Patient?.client?.name }}<br/>
                        <span class="strong">Address:</span> {{ ClientAddress }}<br/>
                        <span class="strong">Phone:</span> {{ Patient?.client?.phone }}
                        <br/>
                        <span class="strong">Fax:</span> {{ Patient?.client?.fax }}<br/>
                    </address>
                </dxi-item>
                <dxi-item *ngIf="order ? order?.reportComment : '' !== ''"  title="Order Comments" class="item-accordion">
                    <div fxLayout="row" fxLayoutAlign="space-between" style="height: 80%">
                        <div [innerHtml]="transformHtml(order ? order.reportComment : '')"
                             style="border: 0; padding: 20px; overflow-x: auto"></div>
                             <!--(onContentReady)="viewerReady($event)"></div>-->
                    </div>
                </dxi-item>
                <dxi-item *ngIf="CancellationReasons" title="Cancellation Reasons" class="item-accordion">
                    <div fxLayout="row" fxLayoutAlign="space-between" style="height: 80%">
                        <div [innerHtml]="transformHtml(CancellationReasons)"
                             style="border: 0; padding: 20px; overflow-x: auto"></div>
<!--                             (onContentReady)="viewerReady($event)"></div>-->
                    </div>
                </dxi-item>
                <dxi-item title="Order Documents" class="item-accordion">
                    <div>
                        <div fxLayout="row" fxLayoutAlign="end">
                            <dx-button [disabled]="isUploading" icon="fa fa-upload" text="Upload"
                                       (click)="fileInput.click()"
                                       style="max-height: 26px; margin-bottom: 4px"></dx-button>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between" style="height: 80%; border: 1px solid #ddd;">
                        <dx-list [items]="docs" height="100%" width="100%"
                                 (onItemClick)="documentClick($event)">
                            <div *dxTemplate="let document of 'item'">
                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <div>{{document?.name}}</div>
                                </div>
                            </div>
                        </dx-list>
                    </div>
                </dxi-item>
            </dx-accordion>
        </div>
        <app-ai-analysis-viewer [orderCode]="order.codeValue" [clientCode]="order.patientClient.code"></app-ai-analysis-viewer>
        <div fxLayout="col" fxLayoutAlign="start">
            <div class="ocl-container-with-padding" style="width: 100%; margin-top: 16px"
                 [ngStyle.lt-md]="{'padding-left': '0', 'padding-right': '0'}">
                <dx-tab-panel
                    [dataSource]="[
                            { id: 1, title: 'Clinical Results', template: 'clinicalResults', visible: clinicalResultsVisible },
                            { id: 2, title: 'Microbiology Results', template: 'microbiologyResults', visible: microbiologyResultsVisible },
                            { id: 3, title: 'Toxicology Results', template: 'toxicologyResults', visible: toxicologyResultsVisible },
                            { id: 4, title: 'Pathology Results', template: 'pathologyResults', visible: pathologyResultsVisible }
                        ]"
                    [selectedIndex]="selectedTab"
                    [loop]="false"
                    [animationEnabled]="true"
                    [swipeEnabled]="false"
                    style="padding-bottom: 16px; width: 100%"
                >
                    <div *dxTemplate="let results of 'clinicalResults'" style="height: 100%; overflow: hidden">
                        <div *ngIf="clinicalResultsVisible" style="height: 100%; overflow: hidden">
                            <app-clinical-results [orderId]="orderId ? orderId : -1"></app-clinical-results>
                        </div>
                    </div>
                    <div *dxTemplate="let results of 'toxicologyResults'" style="height: 100%; overflow: hidden">
                        <div *ngIf="toxicologyResultsVisible" style="height: 100%; overflow: hidden">
                            <app-toxicology-results [orderId]="orderId ? orderId : -1"
                                                    (hasUnexpectedPositive)="hasToxicologyUnexpectedPositiveResults($event)">
                            </app-toxicology-results>
                        </div>
                    </div>
                    <div *dxTemplate="let results of 'microbiologyResults'" style="height: 100%; overflow: hidden">
                        <div *ngIf="microbiologyResultsVisible" style="height: 100%; overflow: hidden">
                            <app-microbiology-results [orderId]="orderId ? orderId : -1"></app-microbiology-results>
                        </div>
                    </div>
                    <div *dxTemplate="let results of 'pathologyResults'" style="height: 100%; overflow: hidden">
                        <div *ngIf="pathologyResultsVisible" style="height: 100%; overflow: hidden">
                            <app-pathology-results [orderId]="orderId ? orderId : -1" [isCancelled]="IsCancelled"></app-pathology-results>
                        </div>
                    </div>
                </dx-tab-panel>
            </div>
        </div>
    </div>
</div>


<dx-speed-dial-action
    icon="print"
    label="Cumulative Results"
    [visible]="isPhoneOrTablet"
    [index]="1"
    (onClick)="openCumulativeResults()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="message"
    label="Email Results"
    [visible]="isPhoneOrTablet"
    [index]="2"
    (onClick)="openEmailFax('email')"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="message"
    label="Fax Results"
    [visible]="isPhoneOrTablet"
    [index]="3"
    (onClick)="openEmailFax('fax')"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>
<dx-speed-dial-action
    icon="print"
    label="Print Results"
    [visible]="isPhoneOrTablet"
    [index]="4"
    (onClick)="printResults()"
    (onContentReady)="onButtonReady($event)">
</dx-speed-dial-action>

<app-signature-dialog
  [popupVisible]="electronicSignaturePopupVisible"
  (closeEvent)="signDialogClosed($event)"
></app-signature-dialog>
<app-signature-unsing-dialog
  [popupVisible]="electronicSignatureUnsignPopupVisible"
  (closeEvent)="unsignDialogClosed($event)"
></app-signature-unsing-dialog>

<app-email-fax-dialog
    [popupVisible]="emailFaxVisible"
    [type]="type"
    [ids]="orderId ? [orderId] : []"
    [from]="'order'"
    (closeEvent)="emailFaxVisible = false">
</app-email-fax-dialog>
